import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["onEvent", "activeAnimationId", "autoplay", "background", "direction", "intermission", "loop", "playMode", "hover", "speed", "renderer", "rendererSettings", "src", "className", "testId", "children", "defaultTheme", "light", "worker", "activeStateId", "lottieRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { a, e, d } from './chunk-XVC7DH25.js';
import { PlayerState, PlayerEvents, DotLottieCommonPlayer, DEFAULT_STATE } from '@dotlottie/common';
import T, { useRef, useEffect, useState, useLayoutEffect, useCallback } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';

var A = function A(e, o, d) {
  var _useState = useState(function () {
    return new DotLottieCommonPlayer(e, o.current, d);
  }),
      _useState2 = _slicedToArray(_useState, 1),
      a = _useState2[0],
      u = useRef(!1);

  return useLayoutEffect(function () {
    function c() {
      return _c.apply(this, arguments);
    }

    function _c() {
      _c = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = !u.current && o.current;

                if (!_context.t0) {
                  _context.next = 6;
                  break;
                }

                u.current = !0;
                a.setContainer(o.current);
                _context.next = 6;
                return a.load();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _c.apply(this, arguments);
    }

    return c(), function () {
      u.current && a.destroy();
    };
  }, [a]), a;
};

function y(e, o) {
  var d$1 = useCallback(function () {
    return o(e.getState());
  }, [o, e]),
      a = useCallback(function (c) {
    return e.state.subscribe(c);
  }, [e]);
  return d(a, d$1, function () {
    return o(DEFAULT_STATE);
  });
}

var me = T.forwardRef(function (_ref, q) {
  var e$1 = _ref.onEvent,
      o = _ref.activeAnimationId,
      d = _ref.autoplay,
      _ref$background = _ref.background,
      a$1 = _ref$background === void 0 ? "transparent" : _ref$background,
      u = _ref.direction,
      c = _ref.intermission,
      L = _ref.loop,
      D = _ref.playMode,
      m = _ref.hover,
      P = _ref.speed,
      _ref$renderer = _ref.renderer,
      $ = _ref$renderer === void 0 ? "svg" : _ref$renderer,
      _ref$rendererSettings = _ref.rendererSettings,
      h = _ref$rendererSettings === void 0 ? {} : _ref$rendererSettings,
      b = _ref.src,
      _ref$className = _ref.className,
      z = _ref$className === void 0 ? "" : _ref$className,
      f = _ref.testId,
      C = _ref.children,
      p = _ref.defaultTheme,
      _ref$light = _ref.light,
      B = _ref$light === void 0 ? !1 : _ref$light,
      _ref$worker = _ref.worker,
      j = _ref$worker === void 0 ? !1 : _ref$worker,
      g = _ref.activeStateId,
      v = _ref.lottieRef,
      I = _objectWithoutProperties(_ref, _excluded);

  var k = useRef(null),
      i = A(b, k, {
    renderer: $,
    activeAnimationId: o,
    rendererSettings: _objectSpread({
      clearCanvas: !0,
      progressiveLoad: !1,
      hideOnTransparent: !0
    }, h),
    hover: m,
    loop: L,
    direction: u,
    speed: P,
    intermission: c,
    background: a$1,
    playMode: D,
    autoplay: m ? !1 : d,
    testId: f,
    defaultTheme: p,
    light: B,
    worker: j,
    activeStateId: g
  }),
      t = useRef(i);
  t.current = i, T.useImperativeHandle(q, function () {
    return i;
  }, [i]), T.useImperativeHandle(v, function () {
    return i;
  }, [i]);
  var S = y(i, function (n) {
    return n.currentState;
  }),
      x = y(i, function (n) {
    return n.frame;
  }),
      G = y(i, function (n) {
    return n.seeker;
  }),
      J = y(i, function (n) {
    return n.currentAnimationId;
  });
  return a(function () {
    typeof L > "u" ? t.current.revertToManifestValues(["loop"]) : t.current.setLoop(L);
  }, [L]), a(function () {
    [PlayerState.Initial, PlayerState.Loading].includes(S) || (typeof d > "u" ? t.current.revertToManifestValues(["autoplay"]) : t.current.setAutoplay(d));
  }, [d]), a(function () {
    typeof u > "u" ? t.current.revertToManifestValues(["direction"]) : t.current.setDirection(u);
  }, [u]), a(function () {
    typeof P > "u" ? t.current.revertToManifestValues(["speed"]) : t.current.setSpeed(P);
  }, [P]), a(function () {
    typeof D > "u" ? t.current.revertToManifestValues(["playMode"]) : t.current.setMode(D);
  }, [D]), a(function () {
    typeof m > "u" ? t.current.revertToManifestValues(["hover"]) : t.current.setHover(m);
  }, [m]), a(function () {
    typeof a$1 > "u" ? t.current.setBackground("transparent") : t.current.setBackground(a$1);
  }, [a$1]), a(function () {
    typeof c > "u" ? t.current.revertToManifestValues(["intermission"]) : t.current.setIntermission(c);
  }, [c]), a(function () {
    typeof p > "u" || !p ? t.current.revertToManifestValues(["defaultTheme"]) : t.current.setDefaultTheme(p);
  }, [p]), a(function () {
    o && t.current.play(o);
  }, [o]), a(function () {
    return typeof g < "u" && t.current.enterInteractiveMode(g), function () {
      t.current.exitInteractiveMode();
    };
  }, [g]), a(function () {
    typeof b < "u" && t.current.updateSrc(b);
  }, [b]), useEffect(function () {
    var n = function n() {
      e$1 == null || e$1(PlayerEvents.Ready);
    },
        w = function w() {
      e$1 == null || e$1(PlayerEvents.DataReady);
    },
        V = function V() {
      e$1 == null || e$1(PlayerEvents.DataFail);
    },
        F = function F() {
      t.current.currentState !== PlayerState.Playing && (e$1 == null || e$1(PlayerEvents.Complete));
    },
        O = function O() {
      e$1 == null || e$1(PlayerEvents.LoopComplete);
    };

    return t.current.addEventListener("DOMLoaded", n), t.current.addEventListener("data_ready", w), t.current.addEventListener("data_failed", V), t.current.addEventListener("complete", F), t.current.addEventListener("loopComplete", O), function () {
      t.current.removeEventListener("DOMLoaded", n), t.current.removeEventListener("data_ready", w), t.current.removeEventListener("data_failed", V), t.current.removeEventListener("complete", F), t.current.removeEventListener("loopComplete", O);
    };
  }, []), useEffect(function () {
    switch (S) {
      case PlayerState.Stopped:
        e$1 == null || e$1(PlayerEvents.Stop);
        break;

      case PlayerState.Paused:
        e$1 == null || e$1(PlayerEvents.Pause);
        break;

      case PlayerState.Playing:
        e$1 == null || e$1(PlayerEvents.Play);
        break;

      case PlayerState.Frozen:
        e$1 == null || e$1(PlayerEvents.Freeze);
        break;

      case PlayerState.Error:
        e$1 == null || e$1(PlayerEvents.Error);
        break;
    }
  }, [S]), useEffect(function () {
    e$1 == null || e$1(PlayerEvents.Frame, {
      frame: x,
      seeker: G
    });
  }, [x]), jsx(e, {
    value: i,
    children: jsxs("div", _objectSpread(_objectSpread(_objectSpread({
      className: "dotlottie-container main ".concat(C ? "controls" : "", " ").concat(z),
      lang: "en"
    }, f && {
      "data-testid": f
    }), I), {}, {
      children: [jsx("div", _objectSpread(_objectSpread({
        ref: k,
        "data-name": "".concat(J),
        role: "figure",
        className: "animation ".concat(C ? "controls" : ""),
        style: {
          position: "relative"
        }
      }, f && {
        "data-testid": "animation"
      }), {}, {
        children: S === PlayerState.Error && jsx("div", _objectSpread(_objectSpread({}, f && {
          "data-testid": "error"
        }), {}, {
          className: "error",
          children: "\u26A0\uFE0F"
        }))
      })), C]
    }))
  });
});
export { me as a };